<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppQuestion',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="21px"
      height="20px"
      viewBox="0 0 21 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="抓潜拓客" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="行业查询-个人模版-编辑提示弹窗-文字提示"
          transform="translate(-685.000000, -311.000000)"
        >
          <g id="编组-2" transform="translate(610.000000, 234.000000)">
            <g id="编组-20" transform="translate(76.000000, 77.000000)">
              <path
                id="矩形"
                d="M10,0.5 C12.6233526,0.5 14.9983526,1.56332372 16.7175144,3.28248558 C18.4366763,5.00164744 19.5,7.37664744 19.5,10 C19.5,12.6233526 18.4366763,14.9983526 16.7175144,16.7175144 C14.9983526,18.4366763 12.6233526,19.5 10,19.5 C7.37664744,19.5 5.00164744,18.4366763 3.28248558,16.7175144 C1.56332372,14.9983526 0.5,12.6233526 0.5,10 C0.5,7.37664744 1.56332372,5.00164744 3.28248558,3.28248558 C5.00164744,1.56332372 7.37664744,0.5 10,0.5 Z"
                stroke="#9CA6B9"
              ></path>
              <path
                id="?"
                d="M10.444,12.392 L10.444,11.748 C10.444,11.552 10.451,11.3863333 10.465,11.251 C10.479,11.1156667 10.5093333,10.992 10.556,10.88 C10.6026667,10.768 10.6703333,10.6606667 10.759,10.558 C10.8476667,10.4553333 10.9666667,10.334 11.116,10.194 C11.3213333,9.998 11.522,9.80433333 11.718,9.613 C11.914,9.42166667 12.0843333,9.221 12.229,9.011 C12.3736667,8.801 12.4903333,8.57233333 12.579,8.325 C12.6676667,8.07766667 12.712,7.8 12.712,7.492 C12.712,7.09066667 12.642,6.73366667 12.502,6.421 C12.362,6.10833333 12.1683333,5.847 11.921,5.637 C11.6736667,5.427 11.3843333,5.26833333 11.053,5.161 C10.7216667,5.05366667 10.3646667,5 9.982,5 C9.59933333,5 9.24,5.05366667 8.904,5.161 C8.568,5.26833333 8.26933333,5.42233333 8.008,5.623 C7.74666667,5.82366667 7.52966667,6.07333333 7.357,6.372 C7.18433333,6.67066667 7.06533333,7.01133333 7,7.394 L7,7.394 L8.26,7.534 C8.33466667,7.07666667 8.519,6.708 8.813,6.428 C9.107,6.148 9.492,6.008 9.968,6.008 C10.4346667,6.008 10.7986667,6.15033333 11.06,6.435 C11.3213333,6.71966667 11.452,7.086 11.452,7.534 C11.452,7.758 11.4146667,7.95866667 11.34,8.136 C11.2653333,8.31333333 11.1696667,8.48133333 11.053,8.64 C10.9363333,8.79866667 10.8056667,8.95033333 10.661,9.095 C10.5163333,9.23966667 10.374,9.38666667 10.234,9.536 C10.0473333,9.72266667 9.89333333,9.88133333 9.772,10.012 C9.65066667,10.1426667 9.55266667,10.2756667 9.478,10.411 C9.40333333,10.5463333 9.34966667,10.698 9.317,10.866 C9.28433333,11.034 9.268,11.2486667 9.268,11.51 L9.268,11.51 L9.268,12.392 L10.444,12.392 Z M9.856,15.248 C10.0706667,15.248 10.2643333,15.1663333 10.437,15.003 C10.6096667,14.8396667 10.696,14.6413333 10.696,14.408 C10.696,14.1746667 10.6143333,13.9763333 10.451,13.813 C10.2876667,13.6496667 10.0893333,13.568 9.856,13.568 C9.62266667,13.568 9.42433333,13.6496667 9.261,13.813 C9.09766667,13.9763333 9.016,14.1746667 9.016,14.408 C9.016,14.6413333 9.10233333,14.8396667 9.275,15.003 C9.44766667,15.1663333 9.64133333,15.248 9.856,15.248 Z"
                fill="#9CA6B9"
                fill-rule="nonzero"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
